import { render, staticRenderFns } from "./paneldynamic-remove-btn.vue?vue&type=template&id=202e30c8&"
import script from "./paneldynamic-remove-btn.vue?vue&type=script&lang=ts&"
export * from "./paneldynamic-remove-btn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/survey-library/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('202e30c8')) {
      api.createRecord('202e30c8', component.options)
    } else {
      api.reload('202e30c8', component.options)
    }
    module.hot.accept("./paneldynamic-remove-btn.vue?vue&type=template&id=202e30c8&", function () {
      api.rerender('202e30c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vue/components/paneldynamic-actions/paneldynamic-remove-btn.vue"
export default component.exports